export const SynonymAPI = {};

const SLICE = 'synonym';

SynonymAPI.create = (content, type, internalId, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/synonym`,
    method:   'POST',
    data:     {
      type:         type,
      internal_id:  internalId,
      content:      content,
    },
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SynonymAPI.delete = (id, type, internalId, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/synonym`,
    method:    'DELETE',
    data:      {
      id: id,
      type: type,
      internal_id: internalId,
    },
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SynonymAPI.update = (id, type, internalId, content, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/synonym`,
    method:   'PUT',
    data:     {
      id: id,
      type: type,
      internal_id: internalId,
      content: content,
    },
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

SynonymAPI.list = (type, internalId, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/synonyms`,
    method:    'GET',
    data:      {
      type: type,
      internal_id: internalId,
    },
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};


